import cloneDeep from 'lodash/cloneDeep';
import { newLogoReachOk64 } from 'reports/base64Images';
import { mixtureSubstancesBySubstance } from 'selectors/generic';
import store from 'source/store';
import theme from 'source/theme';
import { SCENARIO_EF } from 'utils/constants/coreConstants';
import { lcsInternalExposure } from 'utils/constants/lcsTypes';
import { shortDate } from 'utils/helperFunctions/dateFormat';

const themeLight = theme.palette.primary.light;
const themeMain = theme.palette.primary.main;
const lightGrey = '#EEEEEE';

const dataMapping = [
  { id: 'code', name: 'Código MP' },
  { id: 'name', name: 'Nome' },
  { id: 'type', name: 'Tipo' },
  { id: 'cas', name: 'CAS' },
  { id: 'ec', name: 'EC' },
  { id: 'observations', name: 'Observações' },
  { id: 'hazardous', name: 'Perigosa', transform: value => value ? 'Sim' : 'Não' }
];

const rowGenerator = (dataMapping, lcsById, substances, scenarios, rawMaterialsById, shipmentsById) => {
  const clonedSubstances = cloneDeep(substances);
  const rows = [];
  // `substance.mixtures` - the mixtures this substance is part of.
  const mixturesOf = mixtureSubstancesBySubstance(store.getState());
  clonedSubstances.forEach(substance => {
    rows.push(dataMapping.map(field => {
      if (field.transform) {
        return substance[field.id] ?
          { text: field.transform(substance[field.id]), fillColor: themeLight } :
          { text: '', fillColor: themeLight };
      } else {
        return substance[field.id] ?
          { text: substance[field.id], fillColor: themeLight } :
          { text: '', fillColor: themeLight };
      }
    }));

    const mixtureIds = (mixturesOf[substance.id] || []).map(mix => mix.mixture_id);

    scenarios.forEach(scenario => {
      if (
        scenario.type === SCENARIO_EF &&
        scenario.raw_material_supplier_id &&
        lcsInternalExposure.includes(parseInt(scenario.lcs_id)) &&
        (
          substance.id === shipmentsById[scenario.raw_material_supplier_id].raw_material_id ||
          mixtureIds.includes(shipmentsById[scenario.raw_material_supplier_id].raw_material_id)
        )
      ) {

        const shipment = shipmentsById[scenario.raw_material_supplier_id];
        const shipmentRM = rawMaterialsById[shipment.raw_material_id];

        rows.push([
          { text: lcsById[scenario.lcs_id].description },
          { text: scenario.code },
          { text: scenario.designation },
          {
            text: '[ ' + shipment.code + ' ]\r\n' + shipment.trade_name,
            alignment: 'center'
          },
          { text: '[ ' + shipmentRM.code + ' ]\r\n' + shipmentRM.name,
            alignment: 'center'
          },
          { text: scenario.notes, colSpan: 2 },
          {},
        ]);
      }
    });
  });

  return rows;
};

const dd = (substances, lcsById, scenarios, rawMaterialsById, shipmentsById, title) => ({
  pageSize: 'A4',
  pageOrientation: 'landscape',
  pageMargins: [40, 60, 40, 40],

  footer: function (currentPage, pageCount) {
    return {
      text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
      alignment: 'right',
      relativePosition: { x: -15, y: 20 },
      fontSize: 7
    };
  },
  header: function (currentPage, pageCount, pageSize) {
    return [
      {
        image: newLogoReachOk64,
        width: 50,
        relativePosition: { x: 20, y: 10 }
      }
    ];
  },
  content: [
    {
      style: 'header',
      text: title //title,
    },
    {
      style: 'tableExample',
      layout: 'lightHorizontalLines',
      table: {
        headerRows: 2,
        widths: [80, 110, 180, 70, 70, 110, 40],
        body: [
          [
            { text: 'Código MP', fillColor: themeLight },
            { text: 'Nome', fillColor: themeLight },
            { text: 'Tipo', fillColor: themeLight },
            { text: 'CAS', fillColor: themeLight },
            { text: 'EC', fillColor: themeLight },
            { text: 'Observações', fillColor: themeLight },
            { text: 'Perigosa', fillColor: themeLight }
          ],
          [
            { text: 'LCS' },
            { text: 'Código' },
            { text: 'Designação' },
            { text: 'Codigo - MP' },
            { text: '' },
            { text: 'Codigo - Fornecedor' },
            { text: '' },
          ],
          ...rowGenerator(dataMapping, lcsById, substances, scenarios, rawMaterialsById, shipmentsById)
        ]
      }
    }
  ],
  styles: {
    header: {
      color: theme.palette.primary.main,
      fontSize: 16,
      bold: true,
      alignment: 'center'
    },
    tableExample: {
      margin: [0, 15, 0, 0],
      fontSize: 8
    }
  }

});

export default dd;
